import * as React from "react";
import {useEffect, useContext} from "react";
import {Weather} from "../queries/weather";
import {WeatherContext} from "../state/weatherContext";


export const useWeather= () => {
    const {state, dispatch} = useContext(WeatherContext);
    useEffect(() => {
        state === undefined && Weather.getWeatherInfo().then((response) => dispatch({type: "initInfo",payload:response}))
    },[])

    return {weather:state}
}
